export default __webpack_public_path__ + "static/titleBelow-729f9508a9e9d1d01021ae77a719d137.svg";